import { MEETING_STATUS, VOTING_CRITERIA } from "@/constants/meeting";
import { formatDate, getDateRangeObject } from "@/store/helpers";
import service from "@/services/meeting";
import moment from "moment";

const initialAgendaItem = {
  // id: null,
  name: "",
  description: "",
  calculation_method: VOTING_CRITERIA.resident.value,
  votes_in_favor_threshold: 51,
  user_created_item: false,
  confirmed: false,
  files: [],
  new_files: [],
};

const newAgendaItem = (
  calcMethod = VOTING_CRITERIA.resident.value,
  threshold = 51
) => {
  return Object.assign({}, initialAgendaItem, {
    calculation_method: calcMethod,
    votes_in_favor_threshold: threshold,
  });
};

const initialFormState = () => {
  return {
    id: null,
    cooperative_id: null,
    name: "",
    description: "",
    status: "",
    discussion_period: false,
    discussion_period_begin: null,
    discussion_period_end: null,
    voting_period_begin: null,
    voting_period_end: null,
    proposals: false,
    confirmed_at: null,
    confirmed_by: null,
    published: false,
    calculation_method: VOTING_CRITERIA.resident.value, //default value
    participation_threshold: 51,
    votes_in_favor_threshold: 51,
    needs_digital_signature: false,
    raport_comment: "",
    items: [{ ...initialAgendaItem }],
    files: [],
    creator: {},
    new_files: [],
    apartment_groups: [],
    is_signed: false,
    secretary_id: null,
  };
};

const initialSettingsState = () => {
  return { draft_saved: false };
};
const meeting = {
  namespaced: true,
  state: {
    meeting: {
      form: { ...initialFormState() },
      settings: { ...initialSettingsState() },
    },
    meetings: [],
  },

  getters: {
    getId: (state) => {
      return state.meeting.form.id;
    },
    getCooperativeId: (state) => {
      return state.meeting.form.cooperative_id;
    },
    getTitle: (state) => {
      return state.meeting.form.name;
    },
    getDescription: (state) => {
      return state.meeting.form.description;
    },
    isDiscussionPeriod: (state) => {
      return state.meeting.form.discussion_period;
    },
    getDiscussionPeriod: (state) => {
      return getDateRangeObject(
        state.meeting.form.discussion_period_begin,
        state.meeting.form.discussion_period_end
      );
    },
    getVotingPeriod: (state) => {
      return getDateRangeObject(
        state.meeting.form.voting_period_begin,
        state.meeting.form.voting_period_end
      );
    },
    needsDigitalSignature: (state) => {
      return state.meeting.form.needs_digital_signature;
    },
    isProposalsAllowed: (state) => {
      return state.meeting.form.proposals;
    },
    isPublished: (state) => {
      return state.meeting.form.published;
    },
    getParticipationThreshold: (state) => {
      return state.meeting.form.participation_threshold;
    },
    getVotesInFavorThreshold: (state) => {
      return state.meeting.form.votes_in_favor_threshold;
    },
    getCalculationMethod: (state) => {
      return state.meeting.form.calculation_method;
    },
    getConfirmedAt: (state) => {
      return state.meeting.form.confirmed_at;
    },
    getStatus: (state) => {
      return state.meeting.form.status;
    },
    getItems: (state) => {
      return state.meeting.form.items;
    },
    getCreator: (state) => {
      return state.meeting.form.creator;
    },
    getMeetings: (state) => (status) => {
      if (!status) {
        return state.meetings;
      }
      return state.meetings.filter((meeting) => meeting.status === status);
    },
    getDrafts: (state) => (activeCoopId) => {
      return state.meetings.filter(
        (meeting) =>
          meeting.published === false && meeting.cooperative_id === activeCoopId
      );
    },
    getActiveMeetings: (state) => (activeCoopId) => {
      return state.meetings.filter(
        (meeting) =>
          meeting.status === MEETING_STATUS.voting_period &&
          meeting.cooperative_id === activeCoopId
      );
    },
    getOccurred: (state) => (activeCoopId) => {
      return state.meetings.filter(
        (meeting) =>
          meeting.status === MEETING_STATUS.report_done &&
          meeting.cooperative_id === activeCoopId &&
          moment(moment()).isAfter(moment(meeting.confirmed_at).add(14, "days"))
      );
    },
    getPublishedMeetings: (state) => (activeCoopId) => {
      return state.meetings.filter(
        (meeting) =>
          meeting.cooperative_id === activeCoopId &&
          meeting.published === true &&
          (meeting.confirmed_at === null ||
            moment(moment()).isBefore(
              moment(meeting.confirmed_at).add(14, "days")
            ))
      );
    },
    getMeetingById: (state) => (id) => {
      return state.meetings.find((meeting) => meeting.id === Number(id));
    },
    getAgendaItem: (state) => (index) => {
      return state.meeting.form.items[index];
    },
    getAgendaItemById: (state) => (id) => {
      return state.meeting.form.items.find(
        (agenda) => agenda.id === Number(id)
      );
    },
    getRaportComment: (state) => {
      return state.meeting.form.raport_comment;
    },
    getMeetingFiles: (state) => {
      return state.meeting.form.files;
    },
    getMeetingNewFiles: (state) => {
      return state.meeting.form.new_files;
    },
    getUserApartmentGroups: (state, getters) => (meetingId) => {
      return getters.getMeetingById(meetingId)?.apartment_groups;
    },
    getMappedApartmentGroups: (state, getters) => (meetingId) => {
      const asd = [];
      const group = getters.getMeetingById(meetingId)?.apartment_groups;
      group.forEach((a) => {
        a.apartments.forEach((apartment) => {
          const buildingName = apartment.building_name;
          const index = asd.findIndex((e) => e.building === buildingName);
          if (index === -1) {
            asd.push({
              building: buildingName,
              data: [
                {
                  voted: a.voted,
                  group_key: a.group_key,
                  apartment: apartment,
                },
              ],
            });
          } else {
            asd[index] = {
              building: asd[index].building,
              data: [
                ...asd[index].data,
                {
                  voted: a.voted,
                  group_key: a.group_key,
                  apartment: apartment,
                },
              ],
            };
          }
        });
      });
      return asd;
    },
    getMeetingApartmentGroups: (state) => {
      return state.meeting.form.apartment_groups;
    },
    getMeetingApartmentGroupById: (state) => (apartmentId) => {
      return state.meeting.form.apartment_groups.filter(
        (e) => e.group_key === apartmentId
      );
    },
    isSigned: (state) => state.meeting.form.is_signed,
    onlyMine: (state) =>
      state.meeting.form.apartment_groups
        .find(({ group_key }) => group_key === "one_owner")
        ?.apartments.map((apartment) => apartment.id),
    getSecretary_id: (state) => {
      return state.meeting.form.secretary_id;
    },
  },

  mutations: {
    // setSavedState(state, value) {
    //   state.meeting.settings.draft_saved = value;
    // },
    setTitle(state, value) {
      state.meeting.form.name = value;
    },
    setCooperativeId(state, value) {
      state.meeting.form.cooperative_id = value;
    },
    setDescription(state, value) {
      state.meeting.form.description = value;
    },
    setDiscussionPeriodState(state, value) {
      state.meeting.form.discussion_period = value;
    },
    setDiscussionPeriod(state, dateRangeObject) {
      const { start_date, end_date } = dateRangeObject;
      state.meeting.form.discussion_period_begin = formatDate(start_date);
      state.meeting.form.discussion_period_end = formatDate(end_date);
    },
    setVotingPeriod(state, dateRangeObject) {
      const { start_date, end_date } = dateRangeObject;
      state.meeting.form.voting_period_begin = formatDate(start_date);
      state.meeting.form.voting_period_end = formatDate(end_date);
    },
    setProposals(state, value) {
      state.meeting.form.proposals = value;
    },
    setPublished(state, value) {
      state.meeting.form.published = value;
    },
    setCalcMethod(state, value) {
      state.meeting.form.calculation_method = value;
      state.meeting.form.items.forEach(
        (item) => (item.calculation_method = value)
      );
    },
    setParticipationThreshold(state, value) {
      state.meeting.form.participation_threshold = value;
    },
    setVotesInFavorThreshold(state, value) {
      state.meeting.form.votes_in_favor_threshold = Number(value);
      state.meeting.form.items.forEach(
        (item) => (item.votes_in_favor_threshold = Number(value))
      );
    },
    setSignatureRequirement(state, value) {
      state.meeting.form.needs_digital_signature = value;
    },
    setMeetingStatus(state, value) {
      state.meeting.form.status = value;
    },
    updateMeetings(state, meetings) {
      state.meetings = meetings;
    },
    setMeetingValues(state, form) {
      state.meeting.form = Object.assign(form, { new_files: [] });
    },
    resetMeeting(state) {
      state.meeting.form = initialFormState();
      state.meeting.settings = initialSettingsState();
    },
    setItems(state, agenda) {
      state.meeting.form.items = agenda;
    },
    addItem(state) {
      const { calculation_method, votes_in_favor_threshold } =
        state.meeting.form;
      state.meeting.form.items.push(
        newAgendaItem(calculation_method, Number(votes_in_favor_threshold))
      );
    },
    removeItem(state, index) {
      state.meeting.form.items.splice(index, 1);
    },
    updateItem(state, { index, ...item }) {
      const itemObject = state.meeting.form.items[index];
      state.meeting.form.items[index] = Object.assign(itemObject, item);
    },
    clearMeeting(state) {
      state.meetings = [];
      state.meeting = {
        form: { ...initialFormState() },
        settings: { ...initialSettingsState() },
      };
    },
    setRaportComment(state, comment_value) {
      state.meeting.form.raport_comment = comment_value;
    },
    updateMeetingFiles(state, files) {
      state.meeting.form.new_files = [...files];
    },
    removeAgendaItemFile(state, payload) {
      const { agendaId, fileId } = payload;
      const agendaItem = state.meeting.form.items.find(
        (item) => item.id === agendaId
      );
      const files = agendaItem.files.filter(({ id }) => id !== fileId);
      agendaItem.files = files;
    },
    removeMeetingFile(state, fileId) {
      const files = state.meeting.form.files.filter(({ id }) => id !== fileId);
      state.meeting.form.files = files;
    },
    setSecretary_id(state, id) {
      state.meeting.form.secretary_id = id;
    },
  },

  actions: {
    async saveDraft({ state, dispatch }) {
      try {
        if (state.meeting.form.status === "") {
          await dispatch("saveMeeting");
        } else {
          await dispatch("updateMeeting", state.meeting.form);
        }
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(e);
      }
    },

    async saveMeeting({ state, commit }) {
      try {
        const responseData = await service.saveMeeting(state.meeting.form);
        commit("setMeetingValues", responseData);
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(e);
      }
    },

    async updateMeeting({ state, commit, getters }) {
      const meetingId = getters.getId;
      try {
        const responseData = await service.updateMeeting(
          state.meeting.form,
          meetingId
        );
        commit("setMeetingValues", responseData);
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(e);
      }
    },

    async confirmMeeting({ getters, state, commit }) {
      const meetingId = getters.getId;
      try {
        const { status } = await service.confirmMeeting(
          state.meeting.form,
          meetingId
        );
        await commit("setMeetingStatus", status);
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async deleteMeetingConfirm({ getters }) {
      const meetingId = getters.getId;
      try {
        await service.deleteMeetingConfirm(meetingId);
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async deleteMeetingAgendaItem({ getters }, itemId) {
      const meetingId = getters.getId;
      try {
        await service.deleteMeetingAgendaItem(meetingId, itemId);
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(e);
      }
    },

    async publishMeeting({ state, commit, dispatch }) {
      commit("setPublished", true);
      try {
        if (state.meeting.form.status === MEETING_STATUS.draft) {
          await dispatch("updateMeeting");
        } else {
          await dispatch("saveMeeting");
        }
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async updateRaportComment({ state, getters }) {
      const meetingId = getters.getId;
      try {
        await service.updateMeeting(
          {
            raport_comment: state.meeting.form.raport_comment,
          },
          meetingId
        );
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(e);
      }
    },

    async fetchMeetings({ commit }, cooperativeId) {
      try {
        const meetings = await service.getMeetings(cooperativeId);
        commit("updateMeetings", meetings);
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async deleteMeeting({ dispatch }, meetingId) {
      try {
        await service.deleteMeeting(meetingId);
        await dispatch("fetchMeetings");
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async loadMeeting({ commit }, meetingId) {
      // get data
      const meetingData = await service.getMeeting(meetingId);
      // set data
      await commit("setMeetingValues", meetingData);
      await commit("vote/initVotes", meetingData, { root: true });
      return Promise.resolve();
    },
    async deleteAgendaItemFile({ commit, getters }, { agendaId, fileId }) {
      const meetingId = getters.getId;
      try {
        await service.deleteMeetingItemFile(meetingId, agendaId, fileId);
        commit("removeAgendaItemFile", { agendaId, fileId });
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async deleteMeetingFile({ commit, getters }, fileId) {
      const meetingId = getters.getId;
      try {
        await service.deleteMeetingFile(meetingId, fileId);
        commit("removeMeetingFile", fileId);
      } catch (e) {
        return Promise.reject(e);
      }
    },
  },
};

export default meeting;
